import { useParams, useNavigate } from 'react-router-dom';
import { LineItemDetail as LineItemDetailComponent } from '@/components/charting/LineItemDetail';

/**
 * Line Item Detail Page
 * Displays detailed information about a specific line item with its own URL
 */
export default function LineItemDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleClose = () => {
    // Navigate back to the previous page or to the charting queue
    navigate(-1);
  };

  if (!id) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center text-red-600">
          Line item ID is required
        </div>
      </div>
    );
  }

  return (
    <LineItemDetailComponent
      lineItemId={id}
      onClose={handleClose}
      isModal={false}
    />
  );
}
